import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from "react";
import { ELSDrawer } from "components/common/elsevier/Drawer/Drawer";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import { ELSIconButton } from "components/common/elsevier/Button/IconButton";
import CloseIcon from "components/common/elsevier/Icons/CloseIcon";
import DrawerContent from "./DrawerContent";
import Styles from "./Styles.module.scss";

/* eslint react/no-danger: "off" */

// Builds drawer/contents to display event papers for conference event
export default function Drawer(_ref) {
  var updateClose = _ref.updateClose,
    drawerState = _ref.drawerState,
    validateDBSelection = _ref.validateDBSelection,
    dbSelection = _ref.dbSelection;
  // Handles close icon action
  function handleDrawerClose() {
    updateClose();
  }

  // Drawer content layout
  function buildDrawerContent() {
    return /*#__PURE__*/React.createElement("div", {
      role: "dialog",
      "aria-labelledby": "cetitle",
      "aria-modal": "true",
      className: Styles.drawer
    }, /*#__PURE__*/React.createElement(ELSGrid, {
      container: true,
      spacing: 0,
      alignItems: "center",
      className: Styles.drawer__dbContainer
    }, /*#__PURE__*/React.createElement(ELSGrid, {
      id: "confevent",
      item: true,
      xs: 11
    }, /*#__PURE__*/React.createElement("div", {
      "data-cy": "all-available-dbs-title",
      className: Styles.drawer__dbContainer__allDBtitle
    }, /*#__PURE__*/React.createElement("h2", null, "Available databases"))), /*#__PURE__*/React.createElement(ELSGrid, {
      item: true,
      xs: 1,
      justifyContent: "flex-end"
    }, /*#__PURE__*/React.createElement(ELSIconButton, _extends({
      "data-cy": "close-dbs-modal-button",
      "aria-label": "Close Databases side panel"
    }, !dbSelection ? {
      "aria-describedby": "no-db-error"
    } : {}, {
      // no-db-error resides in DatabaseSwitch.js
      className: Styles.drawer__dbContainer__closeButton,
      onClick: function onClick() {
        handleDrawerClose();
      },
      disabled: !dbSelection
    }), /*#__PURE__*/React.createElement(CloseIcon, null)))), /*#__PURE__*/React.createElement(ELSGrid, {
      container: true,
      spacing: 0
    }, /*#__PURE__*/React.createElement(ELSGrid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(DrawerContent, {
      validateDBSelection: validateDBSelection
    }))));
  }

  // Drawer container
  return /*#__PURE__*/React.createElement(ELSDrawer, {
    "data-cy": "drawer",
    open: drawerState,
    onClose: function onClose() {
      return handleDrawerClose();
    },
    sx: {
      "& .MuiDrawer-paper": {
        width: 472,
        boxSizing: "border-box"
      },
      "& .MuiBackdrop-root": {
        backgroundColor: "#DCDCDC",
        opacity: "0.5 !important"
      }
    },
    PaperProps: {
      elevation: 0
    }
  }, buildDrawerContent());
}